import React from "react";
import { BsFacebook, BsGithub, BsInstagram, BsLinkedin } from "react-icons/bs";
import ishtiaq from "../Images/ishtiaq.jpg";

const HomePort = ({ show, setShow }) => {
  return (
    <div className="row overflow-hidden" id="Home" my-5>
      <div className="col-md-6 main_see">
        <h1 data-aos="fade-right" data-aos-duration="1000">
          Hi, I am <span onClick={() => setShow(!show)}> Ishtiaq Ali </span>
        </h1>
        <h2 data-aos-duration="1000" data-aos="fade-right">
          I am a <span>FrontEnd Developer </span>{" "}
        </h2>
        <p className="p" data-aos-duration="1000" data-aos="fade-right">
        I’m a MERN Stack Developer with over 3 years of hands-on experience, including 2 years at Tech Creator. I specialize in building fully responsive, interactive, and high-performance web applications using the MERN stack — MongoDB, Express.js, React.js, and Node.js. My skill set also includes modern frontend technologies like Next.js, TypeScript, Tailwind CSS, Redux, and the Context API for efficient state management. I'm highly proficient in API integration, managing asynchronous data fetching with Axios, and ensuring seamless communication between frontend and backend services. Passionate about solving complex problems and optimizing web performance, I thrive in collaborative environments and am committed to delivering innovative, user-friendly digital experiences.
        </p>
        <div
          className="iconmain"
          data-aos-duration="1000"
          data-aos="fade-down-left"
        >
          <a href=" https://www.facebook.com/profile.php?id=100007947071674 ">
            <BsFacebook className="scialIcon" />
          </a>
          <a href="https://www.instagram.com/ishtiaq_mohmand/">
            <BsInstagram className="scialIcon" />
          </a>
          <a href="http://www.linkedin.com/in/ishtiaq-ali-7389a1267">
            <BsLinkedin className="scialIcon" />
          </a>
          <a href="https://github.com/Ishtiaq-Ali">
            <BsGithub className="scialIcon" />
          </a>
        </div>
      </div>
      <div className="col-md-6 main_see">
        <div
          className="image_div"
          data-aos-duration="1000"
          data-aos="fade-left"
        >
          <img
            src={ishtiaq}
            className="myImagepro"
            alt="Remove the Cursor"
            style={{ objectFit: "contain" }}
          />
        </div>
      </div>
    </div>
  );
};

export default HomePort;
